<mat-dialog-content>
  <h2 class="text-2xl font-semibold text-center mb-4 text-gray-800 mb-3 uppercase">Agregar Concepto de Facturación</h2>
  <form [formGroup]="masterBillingConceptForm" (ngSubmit)="handleCreateMasterBillingConcept()" class="space-y-4">
    <!-- Campos del formulario con estilos consistentes -->
    <div class="flex flex-col">
      <label for="id" class="text-gray-700">ID</label>
      <input id="id" matInput type="text" formControlName="id" placeholder="Ingrese el ID del concepto de facturación"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
      <mat-error
        *ngIf="masterBillingConceptForm.get('id')?.hasError('required') && masterBillingConceptForm.get('id')?.touched">
        El ID es requerido
      </mat-error>
    </div>
    <div class="flex flex-col">
      <label for="providerId" class="text-gray-700">ID del proveedor</label>
      <input id="providerId" matInput type="text" formControlName="providerId" placeholder="Ingrese el ID del proveedor"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
      <mat-error
        *ngIf="masterBillingConceptForm.get('providerId')?.hasError('required') && masterBillingConceptForm.get('providerId')?.touched">El
        ID
        del proveedor es
        requerido</mat-error>
    </div>
    <div class="flex flex-col">
      <label for="concept" class="text-gray-700">Concepto</label>
      <input id="concept" matInput type="text" formControlName="concept"
        placeholder="Ingrese el concepto de facturación"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
      <mat-error
        *ngIf="masterBillingConceptForm.get('concept')?.hasError('required') && masterBillingConceptForm.get('concept')?.touched">El
        concepto es
        requerido</mat-error>
    </div>
    <div class="flex flex-col">
      <label for="description" class="text-gray-700">Descripción</label>
      <input id="description" matInput type="text" formControlName="description"
        placeholder="Ingrese la descripción del concepto de facturación"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
      <mat-error
        *ngIf="masterBillingConceptForm.get('description')?.hasError('required') && masterBillingConceptForm.get('description')?.touched">La
        descripción es
        requerida</mat-error>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="justify-between">
  <button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded" mat-button type="submit"
    [disabled]="!masterBillingConceptForm.valid" (click)="handleCreateMasterBillingConcept()">Agregar
    Concepto de Facturación</button>
  <button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded" mat-button
    (click)="closeModal()">Cancelar</button>
</mat-dialog-actions>